document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('search-modal');
  const input = document.getElementById('predictive-search-input');
  const triggers = document.querySelectorAll('.search-trigger');

  if (!modal || !input) return;

  const closeButtons = modal.querySelectorAll('.search-modal-close');
  const scrim = modal.querySelector('[data-search-modal-scrim]');
  const panel = modal.querySelector('[data-search-modal-panel]');
  const trending = modal.querySelector('[data-search-modal-trending]');

  const showDefaultContent = () => {
    window.searchRecentSearches?.renderRecentSearches();
  };

  const openModal = () => {
    modal.classList.remove('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');

    showDefaultContent();

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        scrim?.classList.remove('opacity-0');
        scrim?.classList.add('opacity-100');
        panel?.classList.remove('translate-y-4', 'opacity-0');
        panel?.classList.add('translate-y-0', 'opacity-100');
        input.focus();
      });
    });
  };

  const closeModal = () => {
    scrim?.classList.remove('opacity-100');
    scrim?.classList.add('opacity-0');
    panel?.classList.remove('translate-y-0', 'opacity-100');
    panel?.classList.add('translate-y-4', 'opacity-0');

    setTimeout(() => {
      modal.classList.add('hidden');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
      input.value = '';
      window.predictiveSearch?.applyState('idle');
    }, 300);
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      openModal();
    });
  });

  closeButtons.forEach((btn) => {
    btn.addEventListener('click', closeModal);
  });

  // The close button sits outside the panel at lg and up, so guard both.
  modal.addEventListener('click', (e) => {
    if (!e.target.closest('[data-search-modal-panel]') && !e.target.closest('.search-modal-close')) {
      closeModal();
    }
  });

  trending?.addEventListener('click', (e) => {
    const pill = e.target.closest('[data-search-term]');
    if (!pill) return;

    e.preventDefault();
    input.value = pill.dataset.searchTerm;
    input.dispatchEvent(new Event('input'));
    input.focus();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.classList.contains('hidden')) {
      closeModal();
    }

    if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
      e.preventDefault();
      if (modal.classList.contains('hidden')) {
        openModal();
      } else {
        closeModal();
      }
    }
  });

  window.searchModal = {
    open: openModal,
    close: closeModal,
    showDefaultContent,
  };
});
